import CircularProgress from 'material-ui/CircularProgress';
import React, { Component } from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import TableHelper from 'src/utils/table-helper';
import { Entities, Projection } from 'src/common/index';
import composeModalActions from 'src/utils/modal-action-wrapper';
import ErrorMessage from 'src/components/misc/error-message';
import DiscountGroupEditModal from 'src/components/administration/discount-group-edit-modal';
import autoBind from 'react-autobind';
import { withTranslation } from 'react-i18next';
import _ from 'lodash';
import BootstrapTableErrorBoundary from 'src/components/error/BootstrapTableErrorBoundary';
import ConfirmDialog from 'src/components/misc/confirm-dialog';
import { ButtonColors } from 'src/utils/constants';
import { IconLabel } from 'src/components/administration/IconLabel';

class DiscountGroupAdministration extends Component {
    constructor(props) {
        super(props);
        autoBind(this);

        this.tableHelper = new TableHelper();
        this.state = {
            startedFetching: false,
        };
    }

    componentWillMount() {
        this.props.fetchByCompanyId(Entities.DISCOUNT_GROUP, this.props.selectedCompany, Projection.FULL);
        this.props.fetchByCompanyId(Entities.BUS, this.props.selectedCompany, Projection.FULL);
    }

    shouldComponentUpdate(nextProps) {
        return !nextProps.modal.open;
    }

    componentWillReceiveProps(nextProps) {
        const { discountGroups, buses } = nextProps;

        if (discountGroups.isFetching && !this.state.startedFetching) this.setState({ startedFetching: true });
        this.tableHelper.processPagination(discountGroups.items.length);

        if (!_.isEqual(discountGroups, this.props.discountGroups)) {
            this.setState({ discountGroups: nextProps.discountGroups });
        }
    }

    componentDidUpdate(prevProps) {
        if (
            this.tableHelper.processPaginationAfterUpdate(
                prevProps.discountGroups,
                this.props.discountGroups,
                this.table,
            )
        )
            this.setState({ renderSelection: !this.state.renderSelection });
    }

    render() {
        const { discountGroups, t, buses } = this.props;
        const finishFetching = this.state.startedFetching && !discountGroups.isFetching;
        const tableData = [];

        if (finishFetching && discountGroups.items.length > 0) {
            discountGroups.items.map(discountGroup => {
                tableData.push({
                    id: discountGroup.id,
                    name: discountGroup.name,
                    discount: discountGroup.discount,
                    calculations: discountGroup.calculations,
                    buses: discountGroup.busDiscountCalculations.length + `/${buses.items.length}`,
                });
            });
        }

        return (
            <div>
                <legend className="legend">
                    {t('administration.discount_groups')}
                    <button
                        className="btn btn-xs btn-blue pull-right"
                        onClick={() => {
                            if (this.table) this.table.reset();
                            this.props.openModal({
                                component: DiscountGroupEditModal,
                                componentProps: {
                                    isCreate: true,
                                },
                                title: t('administration.new_discount_group'),
                                mandatoryFields: true,
                            });
                        }}>
                        <IconLabel icon="plus" text={t('administration.new_discount_group')} />
                    </button>
                </legend>

                {(() => {
                    if (!finishFetching) return <CircularProgress />;
                    else if (discountGroups.error) return <ErrorMessage object={discountGroups} />;
                    else
                        return (
                            <BootstrapTableErrorBoundary>
                                <BootstrapTable
                                    ref={ref => (this.table = ref)}
                                    data={tableData}
                                    exportCSV={true}
                                    striped={true}
                                    hover={true}
                                    condensed={true}
                                    pagination={true}
                                    options={Object.assign({}, this.tableHelper.getOptions(finishFetching))}
                                    selectRow={Object.assign({}, this.tableHelper.getRowProps())}
                                    searchPlaceholder={t('common_phrases.search')}
                                    search={true}>
                                    <TableHeaderColumn
                                        columnTitle={true}
                                        dataField="id"
                                        hidden={true}
                                        isKey={true}
                                        export={true}
                                    />
                                    <TableHeaderColumn columnTitle={true} dataField="name" dataSort={true}>
                                        {t('common_phrases.name')}
                                    </TableHeaderColumn>
                                    <TableHeaderColumn columnTitle={true} dataField="discount" dataSort={true}>
                                        {t('coupons.discount')}
                                    </TableHeaderColumn>
                                    {this.props.busCompany.entity &&
                                    this.props.busCompany.entity.busDiscountGroupEnabled ? (
                                        <TableHeaderColumn columnTitle={true} dataField="buses" dataSort={true}>
                                            {t('companies.buses')}
                                        </TableHeaderColumn>
                                    ) : null}
                                    <TableHeaderColumn
                                        dataField="actions"
                                        width="90"
                                        dataFormat={this.tableActionsFormatter}
                                        export={false}>
                                        {t('common_phrases.actions')}
                                    </TableHeaderColumn>
                                </BootstrapTable>
                            </BootstrapTableErrorBoundary>
                        );
                })()}
            </div>
        );
    }

    tableActionsFormatter(cell, discountGroup) {
        const { t } = this.props;
        return (
            <div>
                <button
                    type="button"
                    className="btn btn-xs transparent"
                    onClick={() =>
                        this.props.openModal({
                            component: DiscountGroupEditModal,
                            componentProps: {
                                id: discountGroup.id,
                                isCreate: false,
                            },
                            title: discountGroup.name,
                            mandatoryFields: true,
                        })
                    }>
                    <span className="glyphicon glyphicon-pencil text-info" />
                </button>
                <button
                    type="button"
                    className="btn btn-xs transparent"
                    title={t('user_functionality.delete')}
                    onClick={() => this.openConfirmDeleteDialog(discountGroup)}>
                    <span className="glyphicon glyphicon-trash text-danger" />
                </button>
            </div>
        );
    }

    openConfirmDeleteDialog(discountGroup) {
        const { t } = this.props;
        if (this.table) this.table.reset();
        this.props.openModal({
            component: ConfirmDialog,
            componentProps: {
                event: discountGroup,
                onProceedDialog: this.onProceedDelete,
                bodyText: t('discount_group.confirm_delete'),
                proceedText: t('user_functionality.delete'),
                cancelText: t('common_phrases.no'),
                cancelButtonColor: ButtonColors.NOTIFY,
                proceedButtonColor: ButtonColors.DANGER,
            },
            title: discountGroup.name,
            noButtons: true,
        });
    }

    onProceedDelete(discountGroup) {
        if (discountGroup) this.props.deleteById(discountGroup.id, Entities.DISCOUNT_GROUP, this.props.selectedCompany);
    }
}

export default withTranslation()(composeModalActions(DiscountGroupAdministration));
